<template>
  <div class="store-info-magic-wrapper">
    <!-- Magical Map Container -->
    <div class="magic-map-container mb-5" v-if="data && data.lat && data.lng">
      <div class="map-overlay-header">
        <i class="far fa-map-marker-alt"></i>
        <span>موقع المتجر الجغرافي</span>
      </div>
      <GmapMap
        class="magic-map"
        :zoom="12"
        :center="{ lat: +data.lat, lng: +data.lng }"
        ref="map"
      >
        <GmapMarker
          :position="{ lat: +data.lat, lng: +data.lng }"
          :draggable="false"
        />
      </GmapMap>
    </div>

    <!-- Section Header Box -->
    <div class="section-header-box mb-4">
      <h4 class="magic-section-title mb-1">
        <i class="far fa-info-circle ml-2 text-primary"></i>
        بيانات المتجر والمعلومات الأساسية
      </h4>
      <p class="text-muted small mb-0">
        المعلومات الأساسية للاتصال وتفاصيل الاسم والتصنيف
      </p>
    </div>

    <!-- Magical Stats Grid -->
    <div class="magic-stats-grid">
      <!-- الاسم (بالعربية) -->
      <div class="magic-stat-card">
        <div class="stat-icon-wrapper blue-gradient">
          <i class="far fa-font"></i>
        </div>
        <div class="stat-content">
          <span class="stat-label">الاسم (بالعربية)</span>
          <h4 class="stat-value">
            {{ data.ar && data.ar.name ? data.ar.name : data.name }}
          </h4>
        </div>
      </div>

      <!-- الاسم (بالانجليزية) -->
      <div class="magic-stat-card">
        <div class="stat-icon-wrapper purple-gradient">
          <i class="far fa-language"></i>
        </div>
        <div class="stat-content">
          <span class="stat-label">الاسم (بالانجليزية)</span>
          <h4 class="stat-value" dir="ltr">
            {{ data.en && data.en.name ? data.en.name : data.name }}
          </h4>
        </div>
      </div>

      <!-- نوع المتجر -->
      <div class="magic-stat-card">
        <div class="stat-icon-wrapper orange-gradient">
          <i class="far fa-store-alt"></i>
        </div>
        <div class="stat-content">
          <span class="stat-label">نوع المتجر</span>
          <h4 class="stat-value">{{ data.store_type || "غير محدد" }}</h4>
        </div>
      </div>

      <!-- لديه وجبات ؟ -->
      <div class="magic-stat-card">
        <div
          class="stat-icon-wrapper"
          :class="data.is_have_meals ? 'green-gradient' : 'red-gradient'"
        >
          <i class="far fa-hamburger"></i>
        </div>
        <div class="stat-content">
          <span class="stat-label">لديه وجبات ؟</span>
          <h4
            class="stat-value"
            :class="data.is_have_meals ? 'text-success' : 'text-danger'"
          >
            {{ data.is_have_meals ? "نعم، يوجد" : "لا يوجد" }}
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data"],
};
</script>

<style lang="scss" scoped>
.store-info-magic-wrapper {
  padding: 0.5rem 0;
  animation: fadeIn 0.5s ease-out forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Magic Section Title */
.section-header-box {
  .magic-section-title {
    color: #1e293b;
    font-weight: 800;
    display: flex;
    align-items: center;
    font-size: 1.25rem;
  }
}

/* Magic Map Container */
.magic-map-container {
  position: relative;
  height: 340px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.03);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 14px 35px rgba(0, 0, 0, 0.08);
  }

  .map-overlay-header {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 10;
    background: rgba(255, 255, 255, 0.92);
    backdrop-filter: blur(12px);
    padding: 8px 18px;
    border-radius: 30px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 700;
    font-size: 13px;
    color: var(--mainColor-2, #783d73);
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);

    i {
      font-size: 14px;
      color: var(--mainColor-2, #783d73);
    }
  }

  .magic-map {
    width: 100%;
    height: 100%;
  }
}

/* Magic Stats Grid */
.magic-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 16px;
}

.magic-stat-card {
  background: #ffffff;
  border-radius: 18px;
  padding: 18px 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.03);
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      120deg,
      transparent,
      rgba(255, 255, 255, 0.6),
      transparent
    );
    transform: translateX(-100%);
    transition: 0.6s;
    pointer-events: none;
  }

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.06);

    &::after {
      transform: translateX(100%);
    }

    .stat-icon-wrapper {
      transform: scale(1.1) rotate(5deg);
    }
  }

  .stat-icon-wrapper {
    width: 52px;
    height: 52px;
    border-radius: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.4rem;
    color: #ffffff;
    transition: transform 0.3s ease;
    flex-shrink: 0;

    &.blue-gradient {
      background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
      box-shadow: 0 6px 16px rgba(79, 172, 254, 0.25);
    }
    &.purple-gradient {
      background: linear-gradient(
        135deg,
        var(--mainColor-2, #783d73) 0%,
        #9b4f95 100%
      );
      box-shadow: 0 6px 16px rgba(120, 61, 115, 0.25);
    }
    &.orange-gradient {
      background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
      box-shadow: 0 6px 16px rgba(250, 112, 154, 0.25);
    }
    &.green-gradient {
      background: linear-gradient(135deg, #10b981 0%, #059669 100%);
      box-shadow: 0 6px 16px rgba(16, 185, 129, 0.25);
    }
    &.red-gradient {
      background: linear-gradient(135deg, #ef4444 0%, #f87171 100%);
      box-shadow: 0 6px 16px rgba(239, 68, 68, 0.25);
    }
  }

  .stat-content {
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .stat-label {
      font-size: 12px;
      color: #94a3b8;
      margin-bottom: 3px;
      font-weight: 600;
    }

    .stat-value {
      font-size: 15px;
      font-weight: 700;
      color: #1e293b;
      margin: 0;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
</style>
